import { Component, OnInit } from '@angular/core';
import { SharedModule } from '../shared.module';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ModalResultsServicesService } from 'src/app/services/modal-results-services.service';
import { ApiRequestsService } from 'src/app/services/api-requests.service';
import { CommonFunctionService } from 'src/app/services/common-function.service';
import { ToastrService } from 'ngx-toastr';
import { DataManipulateService } from 'src/app/services/data-manipulate.service';

@Component({
  selector: 'app-upload-file-modal',
  standalone: true,
  imports: [SharedModule, CommonModule, FormsModule],
  templateUrl: './upload-file-modal.component.html',
  styleUrl: './upload-file-modal.component.scss'
})
export class UploadFileModalComponent implements OnInit {

  fileName: string = "";
  showLoader: boolean = false;
  modelFor: string = "";
  apiName: string = ""
  errorMessage: string = "";
  panValidation: boolean = false;

  file: File | null = null;

  constructor(private common: CommonFunctionService,
    private modalResults: ModalResultsServicesService,
    private ngbActiveModal: NgbActiveModal,
    private modalResult: ModalResultsServicesService,
    private commonApi: ApiRequestsService,
    private toaster: ToastrService,
    private dataManipulateSer: DataManipulateService) { }

  ngOnInit(): void {
    console.log(this.modelFor, this.apiName)
  }

  generateCriteriaObject = (inputJSON: any) => {
    let acknowledgeNo = '';
    let pannum = '';
    let assessementyear = '';
    const selectedType = this.modalResult.selectedType;

    if ((selectedType === 'ClientITR') || (selectedType === 'ITRCopy')) {
      acknowledgeNo = inputJSON?.['e_filing_ackno_no'] ?? '';
      pannum = inputJSON?.['pan'] ?? '';
      assessementyear = inputJSON?.['assessment_year'] ?? '';
    }
    const sendObject = {
      criteria: {
        Type: selectedType,
        acknowledgeNo: acknowledgeNo,
        pannum: pannum,
        assessementyear: assessementyear,
        jsonValue: JSON.stringify(inputJSON),
        userName: this.common.userId,
      }
    };
    return sendObject;
  };

  closeModal(closeOption: string = "close") {
    this.showLoader = false;
    this.fileName = "";
    this.file = null;
    this.ngbActiveModal.close(closeOption);
  }

  onFilechange = async (event: any) => {
    this.file = event.target.files[0] as File;
    this.fileName = this.file ? this.file['name'] : "";

    if (!this.fileName.toLowerCase().endsWith(".pdf")) {
      this.errorMessage = "Invalid file type selected. Only PDF files are allowed.";
      this.toaster.error(this.errorMessage, "Error");
      return;
    }

    let formObject: FormData = new FormData();
    this.modalResult.selectedType = this.modelFor;

    formObject.append("UploadFile", this.file, this.fileName);
    this.showLoader = true;
    this.errorMessage = "";
    
    this.commonApi.uploadFile(this.file, this.apiName, { localPath: this.fileName.split('.')[0], ServingHubLocationId: this.common.servivngLocationId }).subscribe(async (res: any) => {
      if (res['errorCode'] != this.commonApi.NO_ERROR) {
        // this.errorMessage =  (res['errorDescription']).split(':')[1].trim();
        this.errorMessage = res['errorDescription']
        this.showLoader = false;
        this.fileName = "";
        this.file = null;
        return;
      }
      // (x.split(':'))[1].trim();
      try {
        if (res['Data']['clientItr']) {
          const extractedJSon = this.validateJsonStringForClientITR(res['Data']['clientItr']);
          this.modalResult.JSonResult = JSON.parse(extractedJSon);
          this.panValidation = this.modalResult.validatePattern(this.modalResult.JSonResult['pan']);

          const extJson = this.validateJsonString(res['Data']['itrCopy'])
          this.modalResult.itrResult = JSON.parse(extJson);
          this.panValidation = this.modalResult.validatePattern(this.modalResult.JSonResult['pan']);

          setTimeout(() => {
            this.updateRemark();
          }, 10);

          this.toaster.success(res['errorDescription']);
          this.common.id = res['Data']['id'];
          this.common.DocCaseHeaderId = res['Data']['DocCaseHeaderId'];
          this.common.caseProcsessingState = res['Data']['CaseProcessingState'];
          this.common.itrAPIResult = res['Data'];
          // this.common.statusDropdownJson = res['Data'];
          const parsedStatus = JSON.parse(res['reviewerStatusList'][0]['ReviewverStatusJson']);
          this.common.statusDropdownJson = parsedStatus;
          console.log('DropDownData', this.common.statusDropdownJson)

          
        //   if (res['reviewerStatusList'] && res['reviewerStatusList'].length > 0) {
        //     try {
        //         const parsedStatus = JSON.parse(res['reviewerStatusList'][0]['ReviewverStatusJson']);
        //         this.common.statusDropdownJson = parsedStatus;  
        //     } catch (error) {
        //         console.error("Error parsing reviewerStatusList JSON:", error);
        //     }
        // }
        console.log('Process Client Response Data', this.common.itrAPIResult);

       
          if (this.modalResult.selectedType == 'ITRCopy') {
            if (!res['Data']['clientItr']) {
              this.errorMessage = 'The Client ITR information does not exists.';
              this.toaster.error(this.errorMessage, "Error");
              this.showLoader = false;
              this.fileName = "";
              return;
            }
          }

        } else {
          const extractedJSon = this.validateJsonString(res['Data']);

          this.modalResult.JSonResult = JSON.parse(extractedJSon);

          this.panValidation = this.modalResult.validatePattern(this.modalResult.JSonResult['pan']);

          setTimeout(() => {
            this.updateRemark();
          }, 10);
        }

      } catch (ex) {
        // this.errorMessage = "The uploaded file is invalid or not related to Client ITR. Please upload the correct file.";
        this.errorMessage = "The Client ITR information does not exists";
        // this.toaster.error(this.errorMessage, "Error");
        this.showLoader = false;
        this.fileName = "";
        return;
      }

      if (this.modelFor == 'ITRCopy') {
        this.modalResult.pageNumber = 1;
        this.modalResult.totalPages = this.modalResult.JSonResult.length;
      }

      this.showLoader = false;
      this.fileName = "";
      this.modalResult.showPDFFile(this.file);
      this.closeModal();
      this.modalResult.disableSave = false;
      this.modalResult.disableView = false;
    }, (error: any) => {
      this.showLoader = false;
      this.fileName = "";
      this.toaster.error("Error during file upload. Please try again.", "Error");
    });
  }

  validateJsonString = (jsonString: string): string => {
    jsonString = jsonString.replace(/'/g, '"');
    let jsonStringArr = jsonString.split(`,`);
    let returnJsonString = "";

    jsonStringArr.forEach((element: string) => {
      console.log(element, returnJsonString);
      const doublequoteCount = this.getDoubleQuoteCount(element);
      if (doublequoteCount % 2 != 0) {
        element = this.removeAdditionalDoubleQuote(element);
      }
      returnJsonString += element + ",";
    });

    returnJsonString = returnJsonString.substring(0, returnJsonString.length - 1);
    return returnJsonString;
  }

  validateJsonStringForClientITR = (jsonString: string): string => {
    jsonString = jsonString.substring(1, jsonString.length - 1);
    jsonString = jsonString.replace(/'/g, '"');
    let jsonStringArr = jsonString.split(`,`);
    let returnJsonString = "";

    jsonStringArr.forEach((element: string) => {
      const doublequoteCount = this.getDoubleQuoteCount(element);
      if (doublequoteCount % 2 != 0) {
        element = this.removeAdditionalDoubleQuote(element);
      }
      returnJsonString += element + ",";
    });
    returnJsonString = returnJsonString.substring(0, returnJsonString.length - 1);
    if (!returnJsonString.startsWith("{")) returnJsonString = "{" + returnJsonString;
    if (!returnJsonString.endsWith("}")) returnJsonString = returnJsonString + "}";
    return returnJsonString;
  }

  getDoubleQuoteCount = (str: any): number => {
    // const re = new RegExp('"', 'g');
    // const count = str.match(re).length;
    let count = 0;
    for (let i = 0; i < str.length; i++) {
      if (str[i] == '"') count += 1;
    }
    return count;
  }

  removeAdditionalDoubleQuote = (element: string): string => {
    let stringArr = element.split(":");
    let returnStr = "";

    stringArr.forEach((elem: string) => {
      const cnt = this.getDoubleQuoteCount(elem);
      if (cnt > 2) {
        const elemWithoutDoubleQuote = elem.split('"').join("");
        returnStr += '"' + elemWithoutDoubleQuote + '" :'
      } else {
        returnStr += elem + " :"
      }
    })

    returnStr = returnStr.substring(0, returnStr.length - 2);
    return returnStr;
  }

  resetFileAndErrorMessagesOnPopUpOpen = () => {
    this.modalResult.disableSave = true;  
    this.errorMessage = "";
    this.fileName = "";
    this.showLoader = false;
  }

  validateKey = (keyName: string): string => {
    if (this.modalResults.JSonResult[keyName] && this.modalResults.JSonResult[keyName] == this.modalResults.itrResult[keyName]) {
      return "matched";
    } else {
      return "un-matched";
    }
  }

  updateRemark = async () => {
    if (this.modalResults?.JSonResult) {

      const requiredKeys = [
        'name',
        'pan',
        'e_filing_ackno_no',
        'assessment_year',
        'total_income',
        'taxes_paid',
        'date_of_filing'
      ];

      const allKeysMatch = requiredKeys.every(key => this.validateKey(key) === "matched");

      if (allKeysMatch) {

        const name = this.modalResults.JSonResult['name'];
        const panno = this.modalResults.JSonResult['pan'];
        const acknowledgeNo = this.modalResults.JSonResult['e_filing_ackno_no'];
        const assessementyear = this.modalResults.JSonResult['assessment_year'];
        const income = this.modalResults.JSonResult['total_income'];
        const taxPaid = this.modalResults.JSonResult['taxes_paid'];
        const date = this.modalResults.JSonResult['date_of_filing'];
        const incomeRange = this.getIncomeRange(income);
        const taxRange = this.getTaxRange(taxPaid);
        this.modalResults.fixedRemarkForITR = this.generateMatchRemark(name, panno, acknowledgeNo, assessementyear, incomeRange, taxRange, date);
      } else {
        // Clear the remark if any key doesn't match
        this.modalResults.fixedRemarkForITR = "";
        console.log('Cannot generate remark - keys do not match');
      }
    }
  };


  getIncomeRange(income: number): string {
    if (income < 0) {
      return "Income should be positive.";
    }
    const base = 200000;
    const lowerBound = Math.floor(income / base) * base;
    const upperBound = lowerBound + base;

    return `between Rs.${this.formatNumber(lowerBound)} to Rs.${this.formatNumber(upperBound)}`;
  }

  getTaxRange(taxPaid: number): string {
    if (taxPaid < 0) {
      return "Tax paid should be positive.";
    }
    const base = 200000;
    const lowerBound = Math.floor(taxPaid / base) * base;
    const upperBound = lowerBound + base;

    return `between Rs.${this.formatNumber(lowerBound)} to Rs.${this.formatNumber(upperBound)}`;
  }

  formatNumber(num: number): string {
    return num.toLocaleString('en-IN');
  }

  generateMatchRemark(name: string, panno: number, acknowledgeNo: number, assessementyear: number, incomeRange: string, taxRange: string, date: string): string {
    return `ITR verified and found, in the Name ${name} Pan card number ${panno} Acknowledgment no. ${acknowledgeNo} for AY ${assessementyear} Gross total income amount ${incomeRange} and Tax paid is ${taxRange} Date of filing is ${date} which is matching with the details provided to us.`;
  }



}
